import { render } from "./HomeButton.vue?vue&type=template&id=2c255960&scoped=true"
const script = {}

import "./HomeButton.vue?vue&type=style&index=0&id=2c255960&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c255960"]])

export default __exports__